export const ShopperAgentGenerationMode = {
  Template: "template",
  Ai: "ai",
} as const;

export type ShopperAgentGenerationMode =
  (typeof ShopperAgentGenerationMode)[keyof typeof ShopperAgentGenerationMode];

/** Map send-time AI flag (e.g. marketing message llmThreadId) to CRDB enum. */
export function shopperAgentGenerationModeFromAiGenerated(
  aiGenerated: boolean,
): ShopperAgentGenerationMode {
  return aiGenerated
    ? ShopperAgentGenerationMode.Ai
    : ShopperAgentGenerationMode.Template;
}
